<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import AllSubscribers from "@/view/components/subscribers/AllSubscribers.vue";
import AllGuest from "@/view/components/subscribers/AllGuest.vue";
import { getIndex } from "@/utils";
import { getLocations, getLocationGroup } from "@/api/locations";
export default {
  name: "subscribers",
  components: {
    AllSubscribers,
    AllGuest
  },
  data() {
    return {
      tabIndex: 0,
      active_tab: 0,
      locations: [],
      selected_location: null,
      loading: true,
      search: false,
      search2: false,
      selectedItems: [],
      maxDisplay: 1,
      searchTerm: null,
      locationsCopy: [],
      locationsOptions: [],
      location_groups: [],
      selected_location_group: null,
      searchLocationGroupTerm: null,
      selectedLocationGroupItems: [],
      locationGroupsCopy: [],
      locationGroupsOptions: [],
      selectedLocationOrGroup: "locations",
      locationOrGroupOptions: [
        { text: "Locations", value: "locations"},
        { text: "Location Groups", value: "location_groups"}
      ],
      subscriberDispatchFunction: 'getLocationSubscribersPaginated',
      guestDispatchFunction: 'getLocationGuestsPaginated'
    };
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    config() {
      return this.layoutConfig();
    },
    likesAllItems() {
      return this.selectedItems.length === 30  || this.selectedItems.length == this.locationsOptions.length;
    },
    likesSomeItem() {
      return this.selectedItems.length > 0 && !this.likesAllItems;
    },
    icon() {
      if (this.likesAllItems) return "mdi-close-box";
      if (this.likesSomeItem) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    likesAllGroupItems() {
      return this.selectedLocationGroupItems.length === 30  || this.selectedLocationGroupItems.length === this.locationGroupsOptions.length;
    },
    likesSomeGroupItem() {
      return this.selectedLocationGroupItems.length > 0 && !this.likesAllGroupItems;
    },
    groupicon() {
      if (this.likesAllGroupItems) return "mdi-close-box";
      if (this.likesSomeGroupItem) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
          document.title = to.meta.title || 'Aben';
      }
    },
    selected_location() {
      let elems = document.getElementsByClassName("multiselect__content");
      if (elems[0]) {
        // elems[0].setAttribute("class", "democlass");
        elems[0].style.paddingLeft = "0px";
      }
    },
     "selectedItems"(){
      this.loading = false
      if (this.selectedItems.length > 30 && this.selectedLocationOrGroup != 'location_groups') {
        this.$nextTick(() => {
          this.selectedItems = [...this.selectedItems].slice(0, 30)
        })
        swal("Notice", "You've selected too many locations to analyze. Try creating a group of locations to analyze instead")
      }
    },
    "selectedLocationGroupItems"(){
      this.loading = false
      if (this.selectedLocationGroupItems.length > 30  && this.selectedLocationOrGroup != 'locations') {
        this.selectedLocationGroupItems = this.selectedLocationGroupItems.slice(0, 30)
        swal("Notice", "You've selected too many groups to analyze. Try by selecting fewer than 30 groups")
      }
    },
    "selectedLocationOrGroup"(){
       if(this.selectedLocationOrGroup=="locations"){
        this.subscriberDispatchFunction ='getLocationSubscribersPaginated';
        this.guestDispatchFunction = 'getLocationGuestsPaginated'
      }
      else if(this.selectedLocationOrGroup=="location_groups"){
        this.subscriberDispatchFunction ='getLocationGroupSubscribersPaginated';
        this.guestDispatchFunction = 'getLocationGroupGuestsPaginated'
      }      
    }
    
  },
  async beforeMount() {
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Interactions" }]);
    this.$store.commit("setLocationVisibile", false);
    let guest = localStorage.getItem("guest");
    if (guest == "guest") {
      console.log("guest", guest);
      this.active_tab = 1;
    } else {
      this.active_tab = 0;
    }

    const response = await getLocations();
    if (response) {
      this.locations = response;
      let index = getIndex(response);
      let selected = response[index];
      this.selected_location = selected;
      /**
       * this is for the back function if there's a prestored value then it will use the pre stored value, if not then pushes random?
       */
      if (this.$store.getters['getLocationIds'].length > 0 ){
        this.selectedItems = this.$store.getters['getLocationIds']
      }else{
        this.selectedItems.push(selected.id);
      }
  
      this.setLocations();
    }
    const response_location_groups = await getLocationGroup();
    try {
      if (response_location_groups.length) {
        this.location_groups = response_location_groups;
        let group_index = getIndex(response_location_groups);
        let selected_group = response_location_groups[group_index];
        this.selected_location_group = selected_group;

        this.selectedLocationGroupItems.push({
        value: selected_group.id,
        text: `${selected_group.name}`,
        name: selected_group.name,
        });
        setTimeout(() => {
        this.setLocationGroups();
        }, 2000);
      }
    } catch (error) {
      console.log('-- fetching group location:  ', error)
    }

    setTimeout(() => {
      this.onSearch();
    }, 2000);
  },
  methods: {
    clearSubscriberListItem() {
      this.$store.commit("setSubscribersListItem", null);
    },
    customLabel({ name, street }) {
      return `${name} – ${street}`;
    },
    onSearch() {
      if (this.selectedLocationOrGroup == 'locations' && this.selectedItems.length == 0) {
        swal("No locations detected", "Please select at least one location");
        return;
      }
      else if (this.selectedLocationOrGroup == 'location_groups' && this.selectedLocationGroupItems.length == 0) {
        swal("No location groups detected", "Please select at least one location group");
        return;
      }
      this.loading = true;
      this.search = false;
      this.search2 = false;
      
      if (this.selectedLocationOrGroup == 'locations'){
        this.$store.commit(
          "setLocationIds",
          JSON.parse(JSON.stringify(this.selectedItems))
        );
      }
      else if (this.selectedLocationOrGroup == 'location_groups'){
        this.$store.commit(
          "setLocationGroupIds",
          JSON.parse(JSON.stringify(this.selectedLocationGroupItems))
        );
      }
      setTimeout(() => {
        this.loading = false;
        this.search = true;
        this.search2 = true;
      }, 1000);
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllItems) {
          this.selectedItems = [];
        } else {
          let data = [];
          for (let i = 0; i < this.locationsOptions.length; i++) {
            let item = this.locationsOptions[i];
            data.push(item.value);
          }
          this.selectedItems = data;
        }
      });
    },
    setLocations() {
      this.locationsOptions = [
        ...this.locations.map(list => {
          return {
            value: list.id,
            text: `${list.name.replace(list.full_address, '')}`,
            name: `${list.name.replace(list.full_address, '')}`,
            full_address: list.full_address
          };
        })
      ];
      this.locationsCopy = [...this.locationsOptions];
    },
    filterLocations() {
      if (!this.searchTerm || this.locationsOptions.length == 0) {
        this.locationsOptions = this.locationsCopy;
      }
      this.locationsOptions = this.locationsOptions.filter(item => {
        return (
          item.text.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1
        );
      });
    },
    filterLocationsBlur(vl){
      this.searchTerm = null
      this.filterLocations()
    },
    setLocationGroups() {
      this.locationGroupsOptions = [
        ...this.location_groups.map((list) => {
          return {
            value: list.id,
            text: `${list.name}`,
            name: list.name
          };
        }),
      ];
      this.locationGroupsCopy = [...this.locationGroupsOptions];
    },
    toggleLocationGroup() {
      this.$nextTick(() => {
        if (this.likesAllGroupItems) {
          this.selectedLocationGroupItems = [];
        } else {
          let data = [];
          for (let i = 0; i < this.locationGroupsOptions.length; i++) {
            let item = this.locationGroupsOptions[i];
            data.push(item);
          }
          this.selectedLocationGroupItems = data;
        }
      });
    },
    filterLocationGroups() {
      if (!this.searchLocationGroupTerm || this.locationGroupsOptions.length == 0) {
        this.locationGroupsOptions = this.locationGroupsCopy;
      }
      this.locationGroupsOptions = this.locationGroupsOptions.filter((item) => {
        return (
          item.text.toLowerCase().indexOf(this.searchLocationGroupTerm.toLowerCase()) > -1
        );
      });
    },
    filterLocationGroupBlur(){
      this.searchLocationGroupTerm = null
      this.filterLocationGroups()
    },
  }
};
</script>

<style src="@/assets/css/vue-multiselect.min.css"></style>
<style>
.tabs /deep/ .tab-pane:focus {
  outline: none;
}
.subheader {
  background: #e9eaf3 !important;
}
.aside-fixed.subheader-fixed .subheader {
  left: 200px;
}
.aside-minimize.subheader-fixed .subheader {
  left: 70px;
}
.content-box {
  margin-top: 40px;
}
@media only screen and (max-width: 768px) {
  .content-box {
    margin-top: 0px;
  }
}
.location_address {
  font-size: 11px;
  color: rgba (0, 0, 0, 0.54);
}
.v-menu__content {
  max-width: 300px !important;
  /* border: blue solid 2px; */
}
</style>

<template>
  <div>
    <v-app>
      <v-main>
        <!-- Subheader start -->
        
        <div
          class="subheader py-2 py-lg-4 d-flex align-items-center justify-content-center"
        >
          <div class="mr-2 mt-6" style="width: 200px;">
            <v-select
              v-model="selectedLocationOrGroup"
              :items="locationOrGroupOptions"
              required
              dense
              outlined
              background-color="#ffffff"
              height="42"
              :menu-props="{ top: false, offsetY: true }"
            ></v-select>
          </div>
          <div class="mr-2 mt-6" style="width: 350px;"  v-if="selectedLocationOrGroup == 'locations'">
            <v-select
              v-if="selectedLocationOrGroup == 'locations'"
              v-model="selectedItems"
              :items="locationsOptions"
              label="Location"
              multiple
              required
              dense
              outlined
              background-color="#ffffff"
              height="42"
              :menu-props="{ top: false, offsetY: true }"
            >
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-text-field
                      v-model="searchTerm"
                      placeholder="Search"
                      @input="filterLocations"
                      @blur="filterLocationsBlur"
                    ></v-text-field>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
                <v-list-item ripple @click="toggle">
                  <v-list-item-action>
                    <v-icon
                      :color="selectedItems.length > 0 ? 'indigo darken-4' : ''"
                    >
                      {{ icon }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Select All
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
              <template
                v-if="selectedItems.length > 1"
                v-slot:selection="{ item, index }"
              >
                <span v-if="index === maxDisplay">
                  {{ selectedItems.length }} locations selected
                </span>
              </template>
              <template slot="item" slot-scope="{ item, attrs, on }">
                <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                  <v-list-item-action>
                    <v-checkbox
                      :ripple="false"
                      :input-value="active"
                    ></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ item.full_address }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </div>
          <div class="mr-2 mt-6" v-if="selectedLocationOrGroup == 'location_groups'">
            <v-select
              v-if="selectedLocationOrGroup == 'location_groups'"
              v-model="selectedLocationGroupItems"
              :items="locationGroupsOptions"
              required
              dense
              outlined
              background-color="#ffffff"
              height="42"
              return-object
              style="position: relative; z-index: 4;"
              multiple
              :menu-props="{ top: false, offsetY: true }"
            >
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-text-field
                      v-model="searchLocationGroupTerm"
                      placeholder="Search"
                      @input="filterLocationGroups"
                      @blur="filterLocationGroupBlur"
                    ></v-text-field>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
                <v-list-item ripple @click="toggleLocationGroup">
                  <v-list-item-action>
                    <v-icon
                      :color="selectedLocationGroupItems.length > 0 ? 'indigo darken-4' : ''"
                    >
                      {{ groupicon }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Select All
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
              <template
                v-if="selectedLocationGroupItems.length > 1"
                v-slot:selection="{ item, index }"
              >
                <span v-if="index === maxDisplay">
                  {{ selectedLocationGroupItems.length }} location groups selected
                </span>
              </template>
              <template slot="item" slot-scope="{ item, attrs, on }">
                <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                  <v-list-item-action>
                    <v-checkbox :ripple="false" :input-value="active"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.name }}
                    </v-list-item-title>
                    <!-- <v-list-item-subtitle>
                      {{ item.full_address }}
                    </v-list-item-subtitle> -->
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </div>

          <div class="ml-2">
            <v-btn
              depressed
              color="primary"
              id="myBtn"
              @click="onSearch"
              :loading="loading"
              :disabled="loading"
            >
              <v-icon> mdi-magnify </v-icon>
            </v-btn>
          </div>
        </div>
        <!-- Subheader end -->

        <v-card class="content-box">
          <v-tabs
            v-model="active_tab"
            background-color="white"
            color="deep-purple accent-4"
            left
          >
            <v-tab @click="tabIndex = 0">All Marketable</v-tab>
            <v-tab @click="tabIndex = 1">All Trackable</v-tab>
            <v-tab-item :key="0">
              <v-container fluid>
                <all-subscribers
                  v-if="search"
                  :dspfunc="subscriberDispatchFunction"
                ></all-subscribers>
              </v-container>
            </v-tab-item>
            <v-tab-item :key="1">
              <v-container fluid>
                <all-guest
                  v-if="search2"
                  :dspfunc="guestDispatchFunction"
                ></all-guest>
              </v-container>
            </v-tab-item>
          </v-tabs>
          <v-overlay :value="loading">
            <div class="text-center">
              <p>Loading ...</p>
              <v-progress-circular
                indeterminate
                size="30"
              ></v-progress-circular>
            </div>
          </v-overlay>
        </v-card>
      </v-main>
    </v-app>
  </div>
</template>
